import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/arrow-left-s-line.png'


const _hoisted_1 = { class: "card-detail" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "product-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "radio-button" }
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "product-name" }
const _hoisted_11 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "返回",
          class: "back-icon"
        }, null, -1)
      ])),
      _createElementVNode("h1", null, "兑换礼品券: " + _toDisplayString(_ctx.cardName), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["product-item", { selected: _ctx.selectedProduct === product.productId }]),
          onClick: ($event: any) => (_ctx.selectProduct(product.productId))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: 'product-' + product.productId,
              value: product.productId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedProduct) = $event))
            }, null, 8, _hoisted_6), [
              [_vModelRadio, _ctx.selectedProduct]
            ]),
            _createElementVNode("label", {
              for: 'product-' + product.productId
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("img", {
            src: product.mainPic,
            alt: product.productName,
            class: "product-image"
          }, null, 8, _hoisted_8),
          _createElementVNode("div", {
            class: "product-info",
            onClick: ($event: any) => (_ctx.goToProductDetail(product))
          }, [
            _createElementVNode("p", _hoisted_10, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "label" }, "套餐:", -1)),
              _createTextVNode(" " + _toDisplayString(product.productName), 1)
            ])
          ], 8, _hoisted_9)
        ], 10, _hoisted_4))
      }), 128)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "spacer" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "exchange-button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleExchange && _ctx.handleExchange(...args)))
      }, "立即兑换")
    ])
  ]))
}